import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircleLoader } from "react-spinners";
import userPresenter from "./userPresenter";
import LoginForm from "./LoginForm";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isManualOpen, setIsManualOpen] = useState(false);
  const [isManualSubmitting, setIsManualSubmitting] = useState(false);
  const [manualError, setManualError] = useState<string | null>(null);
  const navigate = useNavigate();

  const login = async () => {
    setIsLoading(true);
    try {
      const redirectUrl = await userPresenter.login();
      if (redirectUrl) navigate(redirectUrl);
    } catch (e) {
      console.error(e);
    }
    setIsLoading(false);
  };

  const toggleManual = useCallback(() => {
    setManualError(null);
    setIsManualOpen((prev) => !prev);
  }, []);

  const handleManualLogin = useCallback(
    async (username: string, password: string) => {
      try {
        setManualError(null);
        setIsManualSubmitting(true);
        await userPresenter.manualLogin(username, password);
        navigate("/", { replace: true });
      } catch (error: any) {
        const fallbackMessage = "Invalid username or password.";
        const message = error?.response?.data?.detail || fallbackMessage;
        setManualError(message);
      } finally {
        setIsManualSubmitting(false);
      }
    },
    [navigate]
  );

  const manualToggleLabel = useMemo(
    () => (isManualOpen ? "Hide Manual Login" : "Manual Login"),
    [isManualOpen]
  );

  return (
    <>
      {
        <div className="login-layout d-flex flex-column align-items-center justify-content-center position-relative">
          <div
            className={
              isLoading
                ? "disabled d-flex flex-column justify-content-center align-items-center"
                : "d-flex flex-column justify-content-center align-items-center"
            }
          >
            <div className="d-flex flex-column justify-content-center align-items-center gap-3">
              <div className="login__logo">
                <img src="./crusader-logo.svg" alt="" />
              </div>
              <h2 className="mb-3 text-center">Quality Control Application</h2>
              <div className="login__options">
                <button
                  type="button"
                  className="btn blue-btn font-lg login__option-button"
                  onClick={login}
                  disabled={isLoading}
                >
                  Login with Microsoft
                </button>
                <button
                  type="button"
                  className="btn login__option-button login__option-button--manual"
                  onClick={toggleManual}
                  disabled={isLoading}
                >
                  {manualToggleLabel}
                </button>
              </div>
            </div>
            <CircleLoader
              loading={isLoading}
              color="#36d7b7"
              cssOverride={{
                display: "block",
                margin: "0 auto",
                borderColor: "#36d7b7",
              }}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            {isManualOpen ? (
              <div className="manual-login__container">
                <LoginForm
                  onSubmit={handleManualLogin}
                  isSubmitting={isManualSubmitting}
                  errorMessage={manualError}
                />
              </div>
            ) : null}
          </div>
          <div
            className="d-flex d-md-none flex-column justify-content-end position-absolute"
            style={{ width: "90%", bottom: "0" }}
          >
            <p className="text-center font-md" style={{ color: "#A9A9A9" }}>
              A system To manage caravan production line schedules
            </p>
            <button className="btn blue-btn font-lg" onClick={login}>
              Login with Microsoft
            </button>
            <button
              type="button"
              className="btn login__option-button--manual font-lg mt-2"
              onClick={toggleManual}
            >
              {manualToggleLabel}
            </button>
          </div>
        </div>
      }
    </>
  );
};

export default Login;
